<template>
    <div>
        <dx-grid
            url="payments"
            :columns="columns"
            :title="title"
            :actions="actions"
            :expandedOptions="{
                enabled: true,
                allowExpandingAll: true,
                template: 'payment-details',
            }"
        ></dx-grid>
    </div>
</template>

<script>
import moment from "moment";
import { formatCurrency } from "../utils/helpers.js";

export default {
    data: () => ({
        title: "Payments",
        actions: [],
        columns: [
            {
                field: "statusValue",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                    width: undefined,
                },
                icon: (value, row) => {
                    if (row.isVoided && value == "PROCESSED") {
                        return "mdi-cancel";
                    }

                    switch (value) {
                        case "PROCESSED":
                            return "mdi-check-circle";
                        case "DECLINED":
                            return "mdi-alert";
                        case "ERROR":
                            return "mdi-alert-circle";
                        default:
                            return "";
                    }
                },
                iconColor: (value, row) => {
                    if (row.isVoided && value == "PROCESSED") {
                        return "#aeb8bf";
                    }

                    switch (value) {
                        case "PROCESSED":
                            return "success";
                        case "DECLINED":
                        case "ERROR":
                            return "#f35123";
                        default:
                            return "#aeb8bf";
                    }
                },
            },
            {
                label: "Payment ID",
                field: "paymentID",
                alignment: "left",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "accountID",
                label: "Account ID",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                link: (row) => {
                    return [
                        "DINNER WEB",
                        "DINNER IVR",
                        "DINNER PORTAL",
                        "Dinner App",
                        "DINNER ADMIN PORTAL",
                        "BARCLAYS ONLINE",
                        "BARCLAYS BULK",
                        "BARCLAYS ADMIN",
                    ].includes(row.source)
                        ? "DinnerAccountView"
                        : "Account View";
                },
                showLink: (row) => {
                    return true;
                },
            },
            {
                label: "Amount",
                field: "amount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: new Date(
                    moment()
                        .subtract(1, "month")
                        .add(1, "day"),
                ),
                selectedFilterOperation: ">=",
            },
            {
                label: "From Schedule",
                field: "fromSchedule",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,

                visible: false,
            },
            {
                label: "Imported",
                field: "isImported",
                type: "boolean",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Voided",
                field: "isVoided",
                type: "boolean",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "DDCPaymentID",
                field: "ddcPaymentID",
                visible: false,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Type",
                field: "tranType",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Payment Type",
                field: "paymentType",
                isDropdown: true,
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Source",
                field: "source",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Card Type",
                field: "cardType",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Card Ending",
                field: "cardNumLast5",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Categories",
                field: "categories",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Note",
                field: "comments",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Source Key",
                field: "sourceKey",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Authorization Code",
                field: "authorizationCode",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Transaction Code",
                field: "transactionCode",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },

            {
                label: "User",
                field: "userName",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {
        this.actions.push({
            text: "Pay UTA",
            name: "CustomPayment",
            icon: "mdi-credit-card-plus",
            action: () => {
                this.$router.push({ name: "CustomPayment" });
            },
        });
    },
    methods: {},
};
</script>
<style></style>
